import produce from 'immer'
import { ContactsAction, ContactsActionTypes } from '../actions/contactsActions'
import { ApiStatus, IContactsItem } from '../models'

export const initialContactsState: IContactsState = {
  loadingStatus: ApiStatus.NOTLOADED,
  addingStatus: ApiStatus.NOTLOADED,
  searchingStatus: ApiStatus.NOTLOADED,
  searchString: '',
  contacts: [],
  foundcontacts: [],
  totalDocs: 0,
  errMessage: '',
  errStatus: null,
  errField: null,
}

export default function contactsReducer(state: IContactsState = initialContactsState, action: ContactsAction) {
  return produce(state, (draft) => {
    switch (action.type) {
      case ContactsActionTypes.SEARCH_CONTACTS:
        draft.searchString = action.searchOptions.searchString
        break
      case ContactsActionTypes.SEARCHING_CONTACTS:
        draft.searchingStatus = ApiStatus.LOADING
        draft.loadingStatus = ApiStatus.NOTLOADED
        draft.addingStatus = ApiStatus.NOTLOADED
        break

      case ContactsActionTypes.SEARCHING_CONTACTS_FAILED:
        draft.searchingStatus = ApiStatus.FAILED
        break

      case ContactsActionTypes.FOUND_CONTACTS:
        draft.searchingStatus = ApiStatus.LOADED
        action.keep ? draft.foundcontacts.push(...action.payload.contacts.docs) : (draft.foundcontacts = action.payload.contacts.docs)
        draft.totalDocs = action.payload.contacts.totalDocs
        break

      case ContactsActionTypes.LOAD_CONTACTS:
      case ContactsActionTypes.LOADING_CONTACTS:
        draft.loadingStatus = ApiStatus.LOADING
        draft.addingStatus = ApiStatus.NOTLOADED
        draft.searchingStatus = ApiStatus.NOTLOADED
        draft.foundcontacts = []
        break

      case ContactsActionTypes.LOADING_CONTACTS_FAILED:
        draft.loadingStatus = ApiStatus.FAILED
        break

      case ContactsActionTypes.LOADED_CONTACTS:
        draft.loadingStatus = ApiStatus.LOADED
        draft.contacts = action.payload.contacts.docs
        draft.totalDocs = action.payload.contacts.totalDocs
        break

      case ContactsActionTypes.ADD_CONTACTS:
      case ContactsActionTypes.ADDING_CONTACTS:
        draft.addingStatus = ApiStatus.LOADING
        draft.searchingStatus = ApiStatus.NOTLOADED
        draft.errMessage = ''
        draft.errStatus = null
        draft.errField = null
        break

      case ContactsActionTypes.ADDING_CONTACTS_FAILED:
        draft.addingStatus = ApiStatus.FAILED
        draft.errMessage = action.message
        draft.errStatus = action.status
        draft.errField = action.field
        break

      case ContactsActionTypes.ADDED_CONTACTS:
        draft.addingStatus = ApiStatus.LOADED
        draft.errStatus = 200
        draft.contacts.push(action.payload.contacts.docs[0])
        if (draft.searchString) draft.foundcontacts.push(action.payload.contacts.docs[0])
        break

      case ContactsActionTypes.REMOVE_CONTACT:
        draft.contacts.splice(
          draft.contacts.findIndex((contact) => contact._id === action.payload._id),
          1
        )
        break

      case ContactsActionTypes.SOFT_REMOVE_CONTACTS:
        draft.loadingStatus = ApiStatus.NOTLOADED
        draft.addingStatus = ApiStatus.LOADING
        break

      case ContactsActionTypes.SOFT_REMOVING_CONTACTS:
        draft.loadingStatus = ApiStatus.LOADING
        draft.addingStatus = ApiStatus.LOADING
        break

      case ContactsActionTypes.SOFT_REMOVED_CONTACTS:
        draft.addingStatus = ApiStatus.LOADED
        draft.contacts.splice(
          draft.contacts.findIndex((contact) => contact._id === action.payload._id),
          1
        )
        break

      case ContactsActionTypes.SOFT_REMOVING_CONTACTS_FAILED:
        draft.addingStatus = ApiStatus.FAILED
        draft.errMessage = action.message
        draft.errStatus = action.status
        draft.errField = action.field
        break

      case ContactsActionTypes.EDIT_CONTACTS:
        draft.loadingStatus = ApiStatus.NOTLOADED
        draft.addingStatus = ApiStatus.LOADING
        draft.searchingStatus = ApiStatus.NOTLOADED
        break

      case ContactsActionTypes.EDITING_CONTACTS:
        draft.loadingStatus = ApiStatus.LOADING
        draft.addingStatus = ApiStatus.LOADING
        break

      case ContactsActionTypes.EDITED_CONTACTS:
        draft.addingStatus = ApiStatus.LOADED
        draft.contacts[draft.contacts.findIndex((contact) => contact._id === action.payload._id)] = action.payload
        draft.foundcontacts[draft.foundcontacts.findIndex((contact) => contact._id === action.payload._id)] = action.payload
        break

      case ContactsActionTypes.EDITING_CONTACTS_FAILED:
        draft.addingStatus = ApiStatus.FAILED
        draft.errMessage = action.message
        draft.errStatus = action.status
        draft.errField = action.field
        break
    }
  })
}

export interface IContactsState {
  loadingStatus: ApiStatus
  addingStatus: ApiStatus
  searchingStatus: ApiStatus
  searchString: string
  contacts: IContactsItem[]
  foundcontacts: IContactsItem[]
  totalDocs: number
  errMessage?: string
  errStatus?: number
  errField?: string
}
